import { Component, Watch } from 'vue-property-decorator';
import { cloneDeep, noop } from 'lodash';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import imgPreview from '../imgPreview';
import Upload from '../upload/upload.vue';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import selectGoods from '@/views/components/selectGoods';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  mixins: [style],
  components: {
    Upload,
  },
})
export default class EditProductGroup extends IPSDialog {
  width = '1150px';
  title = '编辑商品组';

  public loadingState = false;

  public productList: Array<GoodsGroupInfo> = [];

  productNewList: Array<GoodsGroupInfo>;

  public productCodes: Array<productCodeClass> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 20;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  public selected: Array<GoodsGroupInfo> = [];

  // 前端排序关键字
  public sortValue = 1;

  public isCloudMall = 0;

  public siteId = 0;

  public empCode = '';

  public options = [
    {
      value: 1,
      label: '上新时间',
    },
    {
      value: 7,
      label: '库存降序',
    },
    {
      value: 5,
      label: '销量降序',
    },
    {
      value: 6,
      label: '折扣降序',
    },
    {
      value: null,
      label: '手工排序',
    },
    {
      value: 4,
      label: '价格升序'
    },
    {
      value: 3,
      label: '价格降序'
    }
  ];

  selectType = 1;
  cloneData = [];
  shareImage = '';
  shareInfo = '';
  @Watch('productList')
  watchProductList(n, o) {
    this.totalCount = n.length;
  }

  @Watch('productNewList', { deep: true, immediate: true })
  watchProductNewList(n, o) {
    this.productNewList = n;
    if (this.productNewList && this.productNewList.length > 0) {
      this.productList = this.productNewList;
      this.cloneData = cloneDeep(this.productList);
    }
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchSite(e?): void {
    if (e && e.keyCode !== 13) {
      return;
    }
    this.page = 1;
    this.pageSize = 20;
    if (this.keywords) {
      this.productList = this.cloneData.filter((arr) => {
        return arr.productCode.toLowerCase().match(this.keywords.toLowerCase()) || arr.productName.toLowerCase().match(this.keywords.toLowerCase());
      });
    } else {
      this.productList = this.cloneData;
    }
  }

  getProductList() {
    const postParams = {
      siteId: this.siteId,
      productState: 9,
      page: 1,
      pageSize: this.productCodes.length,
      productCodes: this.productCodes.map(i => i.c),
      isOnlyBase: 1,
    };
    IPSService.siteProductList({ postParams }).then((res) => {
      let list = [];
      if (this.productCodes.length === res.list.length) {
        this.productCodes.forEach((key) => {
          list.push(
            res.list.find((v: any) => {
              return v.productCode === key.c;
            }),
          );
        });
        list = list.filter(v => !!v);
        this.productList = list.map((i: any, index) => {
          i.sort = this.productCodes[index].s;
          i.productImage = i.productImage || i.productImages[0];
          return i;
        }) as GoodsGroupInfo[];
        this.cloneData = cloneDeep(this.productList);
      } else {
        const list = res.list.map(item => item.productCode);
        const code = this.productCodes.filter((item) => {
          return !list.includes(item.c);
        });
        const postParams = {
          siteId: this.siteId,
          isCloudMall: this.isCloudMall,
        };
        postParams[`productCode${code.length > 1 ? 's' : ''}`] = code.map(i => i.c).join(',');
        IPSService.adminComBatchFindProducts({ postParams }).then((res) => {
          let list = [];
          this.productCodes.forEach((key) => {
            list.push(
              res.list.find((v: any) => {
                return v.productCode === key.c;
              }),
            );
          });
          list = list.filter(v => !!v);
          this.productList = this.productList.concat(list).map((i: any, index) => {
            i.sort = this.productCodes[index].s;
            i.productImage = i.productImage || i.productImages[0];
            return i;
          }) as GoodsGroupInfo[];
          this.cloneData = cloneDeep(this.productList);
        });
      }
    });
  }

  mounted() {
    if (this.productCodes && this.productCodes.length > 0) {
      this.getProductList();
    }
    const list = this.options.map((i) => {
      return i.value;
    });
    if (!list.includes(this.sortValue)) {
      this.sortValue = 1;
    }
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
  }

  /**
   * 删除
   * @param {number | string} siteCode
   * @returen null
   */
  public onDelete(val): void {
    this.productList = this.productList.filter(item => item.productCode !== val.productCode);
    this.cloneData = this.cloneData.filter(item => item.productCode !== val.productCode);
  }

  public batchDel(): void {
    if (!this.selected || !this.selected.length) {
      return;
    }
    this.$confirm(`确认将当前选中的${this.selected.length}件商品删除？`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        const productIds = this.selected.map(v => v.productCode);
        this.productList = this.productList.filter((item) => {
          return !productIds.includes(item.productCode);
        });
        this.cloneData = this.cloneData.filter((item) => {
          return !productIds.includes(item.productCode);
        });
        this.page = 1;
        this.pageSize = 20;
      }
    });
  }

  // 选中
  onSelected(val) {
    this.selected = val;
  }

  beforeConfirm() {
    const results = this.cloneData;
    if (!results || !results.length) {
      this.confirmloading = false;
      this.$message.warning('请选择商品');
      return;
    }
    const result = { list: results, productSort: this.sortValue, shareImage: this.shareImage, shareInfo: this.shareInfo };
    this.$emit('result', result);
    this.$emit('hidden');
  }

  onImgPreview(img) {
    imgPreview.open({ img }).then(noop, noop);
  }

  // 分页列表
  get tableList() {
    let list: Array<GoodsInfo> = [];
    // 按照sort字段从大到小排序
    this.productList = this.productList.sort((a, b) => b.sort - a.sort);
    this.cloneData = this.cloneData.sort((a, b) => b.sort - a.sort);
    list = this.productList.length > this.pageSize ? this.productList.slice(this.pageSize * (this.page - 1), this.pageSize * this.page) : this.productList;
    return list;
  }

  openSelectGoodsDialog() {
    if (this.productCodes.length > 1000) {
      this.$message.error('最多支持添加1000个商品');
      return;
    }
    selectGoods
      .open({
        showBD: false,
        max: 1000 - this.productCodes.length,
        empCode: this.empCode,
        siteId: this.siteId,
        isCloudMall: this.isCloudMall,
      })
      .then((res) => {
        this.selectType = res.type;
        res.list.map((i) => {
          if (this.productList.every(v => i.productCode !== v.productCode)) {
            this.productList.push(i);
          } else {
            this.productList.map((res) => {
              if (i.productCode === res.productCode) {
                res.sort = i.sort;
              }
            });
          }
          if (this.cloneData.every(v => i.productCode !== v.productCode)) {
            this.cloneData.push(i);
          } else {
            this.cloneData.map((res) => {
              if (i.productCode === res.productCode) {
                res.sort = i.sort;
              }
            });
          }
        });
      }, noop);
  }

  sortBlur(val) {
    if (val === undefined) {
      this.$message.warning('请输入序号');
      return;
    }
  }

  sortChange(val) {
    console.log(val);
    this.cloneData.map(v => (v.productCode === val.productCode ? (v.sort = val.sort) : v.sort));
  }

  onExportFile() {
    Functions.excelMaker({
      columns: [
        { header: '图片', key: 'productImage', width: 50 },
        { header: '货号', key: 'productCode', width: 15 },
        { header: '名称', key: 'productName', width: 20 },
        { header: '排序', key: 'sort', width: 20 },
      ],
      data: this.productList,
      name: '商品数据模板',
    });
  }
  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.shareImage = res.content;
  }
  renderContent(h) {
    return (
      <div class="r-px-20">
        <div class="flex-inline items-center border-bottom-white hei-28 width-100 line-height-56 border-box">
          <div class="flex-inline items-center hei-16 relative-position fl" style="width:98%">
            <el-input
              v-model={this.keywords}
              placeholder="搜索商品货号/商品名称"
              nativeOn-keyup={(e) => {
                this.onSearchSite(e);
              }}></el-input>
            <i class="wid-15 hei-15 top-12 line-height-8 font-size-18 text-grey-15 absolute right-0 cursor-pointer iconfont iconsousuo" onClick={() => this.onSearchSite()}></i>
          </div>
          <div class="flex-inline items-center font-size-18 hei-16 relative-position fr">
            <el-dropdown class="font-center wid-13">
              <i class="el-icon-more rotate-90"></i>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <span onClick={() => this.onExportFile()}>导出为Excel</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <el-table key={1} v-loading={this.loadingState} height="350" style="width: 100%" data={this.tableList} ref="multipleTable" on-selection-change={this.onSelected}>
          <el-table-column type="selection" width="50" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column type="index" label="#" width="50" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="productImage"
            label="图片"
            width="60px"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <img class="wid-16" src={scope.row.productImage} onClick={this.onImgPreview.bind(this, scope.row.productImage)} />;
                },
              },
            }}></el-table-column>
          <el-table-column prop="productCode" label="商品货号" width="200px" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="商品名称" min-width="120px" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="排序"
            prop="sort"
            align="center"
            width="90px"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <el-input-number
                      v-model={scope.row.sort}
                      controls={false}
                      class="wid-35 line-height-32"
                      min={0}
                      max={9999}
                      disabled={this.sortValue !== null}
                      onChange={() => {
                        this.sortChange(scope.row);
                      }}
                      onBlur={() => this.sortBlur(scope.row.sort)}></el-input-number>
                  );
                },
              },
            }}
          />

          <el-table-column
            label="操作"
            align="center"
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return (
                    <span class="scopeSpan" onClick={this.onDelete.bind(this, scoped.row)}>
                      删除
                    </span>
                  );
                },
              },
            }}
          />
        </el-table>
        <div class="hei-21 r-mt-10 r-py-0 border-bottom-white">
          <el-button type="primary" onClick={this.openSelectGoodsDialog.bind(this)}>
            添加商品
          </el-button>
          <span class={[(!this.selected || !this.selected.length) && 'disabled r-mx-16', 'scopeSpan r-mx-16']} onClick={this.batchDel.bind(this)}>
            批量删除
          </span>

          <div class="fr">
            <el-pagination
              on-size-change={this.onSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 20, 30, 100]}
              page-size={this.pageSize}
              pager-count={5}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}></el-pagination>
          </div>
        </div>
        <div class="formWrapper r-mt-10 border-bottom-white">
          <el-form props={{ model: {} }} label-position="left" inline={true} label-width="70px" ref="form">
            <div class="formItemWrapper">
              <el-form-item label="前端排序">
                <el-select class="wid-60" v-model={this.sortValue}>
                  {this.options.map((item) => {
                    return <el-option key={item.value} label={item.label} value={item.value}></el-option>;
                  })}
                </el-select>
              </el-form-item>
              <el-form-item class="r-ml-16 r-mb-0" label="分享配置">
                <div>
                  <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} fileList={false} img={this.shareImage} maxSize={300} /></div>
              </el-form-item>
              <el-form-item class="r-mt-10" label="">
                <el-input class="wid-160" placeholder="请输入分享描述信息" v-model={this.shareInfo} />
                <p class="tip blockTip r-mt-58">注1：建议图片分辨率为800*640px；</p>
                <p class="tip blockTip">注2：图片大小不超过300k，支持jpg、jpeg、gif、png格式。</p>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    );
  }
}
